<script setup lang="ts">
import { scrollToTop } from '@/utils/util'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

defineProps<{
  activeClass: string
}>()

const route = useRoute()
const isActive = computed(() => route.path === '/' || route.path === '/home')
</script>

<template>
  <RouterLink
    to="/"
    replace
    :aria-label="$t('home.title')"
    :class="{ '!text-primary': isActive }"
    active-class=""
    exact-active-class=""
    flex
    flex-col
    text-second
    items-center
    place-content-center
    h-full
    flex-1
    class="coarse-pointer:select-none"
    @click="scrollToTop">
    <div i-octicon:home-24 text-6.5 />
    <div text-xs mt-0.5>{{ $t('home.title') }}</div>
  </RouterLink>
</template>
